import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "_fallbackIcon",
  "use": "_fallbackIcon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"_fallbackIcon\"><g clip-path=\"url(#_fallbackIcon_clip0_158_7)\"><path fill-opacity=\".01\" d=\"M0 0h16v16H0z\" /></g><defs><clipPath id=\"_fallbackIcon_clip0_158_7\"><path d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol